import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Container } from './Container';

type DragDropAreaProps = {
  onFileDropped: (files: File[]) => void;
};

const DragDropArea = ({ onFileDropped }: DragDropAreaProps) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Container onFileDropped={onFileDropped} />
    </DndProvider>
  );
};

export default DragDropArea;
